<template>
  <div>
    <div class="organism-head">
      <h1>Liste des utilisateurs</h1>
      <user-form-btn @refresh="shouldRefresh = !shouldRefresh"/>
    </div>
    <user-table :refresh="shouldRefresh"/>
  </div>
</template>

<script>
import UserFormBtn from './UserFormBtn.vue';
import UserTable from './UserTable.vue';

export default {
  components: {
    UserFormBtn,
    UserTable,
  },
  data() {
    return {
      shouldRefresh: false,
    };
  },
};
</script>

<style scoped>
.organism-head {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
}
</style>
